import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimary from '@/views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-furnitureshop-grid-slider-02.js';

const slides = [
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0c0c44019f375ea816039.webp?w=1000',
    content: '<h2 style="text-align: center"><strong>Paintwork</strong></h2>',
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0c0e64e700aaf95ba6346.webp?w=1000',
    content: '<h2 style="text-align: center"><strong>Headlights</strong></h2>',
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0c0eab42d1210f20ee492.webp?w=1000',
    content: '<h2 style="text-align: center"><strong>Windows</strong></h2>',
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0c109986be4c5a81eab4e.webp?w=1000',
    content: '<h2 style="text-align: center"><strong> Plastic Trim</strong></h2>',
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0c10cbdd294624c00dd86.webp?w=1000',
    content: '<h2 style="text-align: center"><strong>Wheels</strong></h2>',
  },
];

const renderSlide = ({ image, content }) => `
  <div class="swiper-slide" data-attribute="furnitureshop-grid-slider-02__slide">
    <article class="furnitureshop-grid-slider-02__card">
      <img
        class="furnitureshop-grid-slider-02__image"
        data-attribute="furnitureshop-grid-slider-02__image"
        src="${image}"
        alt=""
      />
      <div
        class="furnitureshop-grid-slider-02__slide-content"
        data-attribute="furnitureshop-grid-slider-02__slide-content"
      >
        ${content}
      </div>
    </article>
  </div>
`;

const buttonHtml = buttonPrimary({
  text: 'BUY NOW',
  backgroundColor: '#FF8100',
  color: '#FFFFFF',
  radius: 4,
  iconPrefix: { show: false, src: '' },
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/08/19/image-6a85790b9a1e4455d92f0d2b.avif?w=200',
  },
  subBtn: { show: false, text: '' },
});

const contentHtml = `
  <div
    class="furnitureshop-grid-slider-02 container"
    data-attribute="furnitureshop-grid-slider-02"
  >
    <header
      class="furnitureshop-grid-slider-02__header"
      data-attribute="furnitureshop-grid-slider-02__header"
    >
      <div
        class="furnitureshop-grid-slider-02__title"
        data-attribute="furnitureshop-grid-slider-02__title"
      >
        <h2>
          <span style="font-size: 40px"><strong>Safe for Paint,</strong></span><br />
          <span style="font-size: 40px"><strong>Safer for You</strong></span>
        </h2>
      </div>
      <div
        class="furnitureshop-grid-slider-02__heading"
        data-attribute="furnitureshop-grid-slider-02__heading"
      >
        <img
          class="furnitureshop-grid-slider-02__decor"
          data-attribute="furnitureshop-grid-slider-02__decor"
          src="https://cdn.skyfastimg.com/images/2026/08/20/image-6a86740aab3a65f2691e0790.png?w=500"
          alt=""
        />
        <div
          class="furnitureshop-grid-slider-02__description"
          data-attribute="furnitureshop-grid-slider-02__description"
        >
          <p>pH-balanced, biodegradable formula: skin-safe,<br />paint-friendly, and leaves zero toxic residues behind.</p>
        </div>
      </div>
    </header>

    <div class="furnitureshop-grid-slider-02__carousel">
      <div class="swiper furnitureshop-grid-slider-02__swiper">
        <div
          class="swiper-wrapper"
          data-attribute="furnitureshop-grid-slider-02__list"
        >
          ${slides.map(renderSlide).join('\n')}
        </div>
      </div>
      <button
        type="button"
        class="furnitureshop-grid-slider-02__navigation furnitureshop-grid-slider-02__navigation--prev"
        aria-label="Previous slide"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6" /></svg>
      </button>
      <button
        type="button"
        class="furnitureshop-grid-slider-02__navigation furnitureshop-grid-slider-02__navigation--next"
        aria-label="Next slide"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6" /></svg>
      </button>
    </div>
    <div class="furnitureshop-grid-slider-02__pagination"></div>
    <div class="furnitureshop-grid-slider-02__cta" data-attribute="furnitureshop-grid-slider-02__cta">
      ${buttonHtml}
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#2A2A2A',
  textColor: '#FFFFFF',
});
